export enum RxAssistantOperatorModes {
    PACK = 1,
    PLOCKKONTROLL = 2,
    PACK_PLOCKKONTROLL = 3
  }